import { Box, Icon, PressableIcon, Text } from '@bonanza-social/moonlight';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useCallback } from 'react';
import { rewardBadgeMap } from './ReferrerContent.constants';
import { Promotion } from '../../../../services/RegistrationOffersService/RegistrationOffersService.schemas';
import { formatCompact } from '@bonanza-social/toolkit/utils';
import { useTranslation } from '@bonanza-social/i18n';

function ReferrerContent({ promotion }: { promotion: Promotion }) {
  const { t } = useTranslation('registration');
  const navigation =
    useNavigation<StackNavigationProp<AuthNavigatorParamsList>>();
  const handleClick = useCallback(
    () => navigation.navigate('RAFTerms'),
    [navigation],
  );

  return (
    <Box flex={1} flexDirection="row" alignItems="center">
      <Box flex={1} flexDirection="row">
        <Box padding="space-200">
          <Box flexDirection="row" gap="space-100" alignItems="center">
            <Icon
              name={
                rewardBadgeMap[promotion.rewards[0].rewardTarget] ?? 'freeSpins'
              }
              gradient="accentBackground"
              width="space-500"
              height="space-500"
            />
            <Text variant="body-m-semi" color="darkSurfacePrimary">
              {formatCompact(promotion.rewards[0].rewardAmount)}
            </Text>
            <Text variant="body-m-semi" color="darkSurfacePrimary">
              {promotion.rewards[0].rewardTarget}
            </Text>
          </Box>
          <Box>
            <Text variant="body-s" color="darkSurfaceSecondary">
              {t('asReferrerInvitedYou', {
                referrer: promotion.subTypeMeta?.referrerName,
              })}
            </Text>
          </Box>
        </Box>
      </Box>
      <PressableIcon
        marginRight="space-200"
        name="info"
        color="iconSecondary"
        width={23}
        height={23}
        onPress={handleClick}
      />
    </Box>
  );
}

export default ReferrerContent;
